module.exports = __webpack_public_path__ + "img/gal_36.2dff6c20.png";